import { useMemo } from 'react';
import { EquipmentModel } from '../../data/types';
import { TaskStatus } from '../../data/enums';
import { useInspection } from '../useInspection';
import InspectionUndercarriageSideScreenService from './inspectionUndercarriageSideScreen.service';

const defaults = {
  sideFrameIndicator: TaskStatus.notStarted,
  pitchExtensionIndicator: TaskStatus.notStarted,
  shoeRollerPathIndicator: TaskStatus.notStarted,
  shoeDriveLugIndicator: TaskStatus.notStarted,
  tumblerRollerPathIndicator: TaskStatus.notStarted,
  tumblerDriveLugIndicator: TaskStatus.notStarted,
  engagementIndicator: TaskStatus.notStarted,
  frontIdlerIndicator: undefined as TaskStatus | undefined,
  rearIdlerIndicator: undefined as TaskStatus | undefined,
  loadRollersIndicator: undefined as TaskStatus | undefined,
  returnRollersIndicator: undefined as TaskStatus | undefined,
  slidersIndicator: undefined as TaskStatus | undefined,
};

const useInspectionUndercarriageTableOfContentsIndicator = (
  inspectionId: string,
  equipment?: EquipmentModel,
) => {
  const { inspection, isLoadingInspection } = useInspection(inspectionId);

  const indicators = useMemo(() => {
    if (!inspection || !equipment) return defaults;
    const service = new InspectionUndercarriageSideScreenService(
      inspection,
      equipment,
    );
    return service.getSideIndicators();
  }, [inspection, equipment]);

  // Optional: expose readiness so the UI can show a skeleton until both are present
  const isReady = !!inspection && !!equipment && !isLoadingInspection;

  return { ...indicators, isReady };
};

export default useInspectionUndercarriageTableOfContentsIndicator;
